(() => {
  'use strict';
  function initialize(scope) {
    scope.querySelectorAll('[data-st-prizes]').forEach(root => {
      if (root.dataset.initialized) return;
      const controls = root.querySelector('[data-stp-controls]');
      const buttons = Array.from(root.querySelectorAll('[data-stp-select]'));
      const panels = Array.from(root.querySelectorAll('[data-stp-panel]'));
      const announcement = root.querySelector('[data-stp-announcement]');
      if (!controls || buttons.length !== 3 || panels.length !== 3) return;
      function select(value, announce) {
        const panel = panels.find(item => item.dataset.stpPanel === value);
        if (!panel) return;
        panels.forEach(item => { item.hidden = item !== panel; });
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.stpSelect === value)));
        if (announce && announcement) announcement.textContent = panel.querySelector('h3').textContent;
      }
      buttons.forEach(button => button.addEventListener('click', () => select(button.dataset.stpSelect, true)));
      select('1', false);
      controls.hidden = false;
      root.dataset.initialized = 'true';
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
